export default __webpack_public_path__ + "static/media/loading.196f3063.svg";